<template>
    <fieldset aria-describedby="content-info-text">
        <legend
            v-if="listHeading"
            :id="uniqueId"
            class="legendelement"
        >
            {{ $t(listHeading) }}
        </legend>
        <div class="dropdownelement">
            <div
                :key="forceUpdateKey"
                class="dropdown"
            >
                <select
                    v-model="selectedValue"
                    :aria-labelledby="uniqueId"
                    @change="changeDropDown(selectedValue)"
                >
                    <option
                        v-for="(option, i) in dropdownItems"
                        :key="i"
                        :value="option.identifier"
                        :selected="option.identifier === selectedValue"
                    >
                        {{ $t(option.labelText) }}
                    </option>
                </select>
            </div>
        </div>
    </fieldset>
</template>

<script lang="ts">
    import { Vue, Component, Prop, Emit, Watch } from "vue-facing-decorator"
    import DropDownListModel from "@/models/dropdownlistmodel"

    /** Dropdown/Select komponentti */
    @Component
    export default class DropdownList extends Vue {
        selectedValue: string = ""
        uniqueId: string = ""
        forceUpdateKey = 0

        /** * Dropdownissa näytettävät arvot */
        @Prop({ type: Array, default: [] }) dropdownList!: Array<DropDownListModel>
        /** Komponentin yläpuolella näytettävä otsikko */
        @Prop() listHeading: string | undefined
        /** Valittu oletusarvo, Anna DropDownListModel.value, ei labelText tai indeksiä*/
        @Prop() defaultItem: string | undefined

        /** Muokataan valintoja -> palauttaa valitun arvon */
        @Emit("selectedDropdown")
        changeDropDown() {
            return this.selectedValue
        }

        created() {
            this.uniqueId = "id-" + Math.random().toString(16).slice(2)
        }

        mounted(): void {
            this.selectedValue = this.defaultItem ? this.defaultItem : ""
        }

        async activated(): Promise<void> {
            this.forceUpdateKey += 1
        }

        get dropdownItems(): DropDownListModel[] {
            return this.dropdownList
        }

        /** Tyhjennetään valittu arvo jos dropdownlista muuttuu */
        @Watch("dropdownList")
        clearSelectedValue() {
            this.selectedValue = ""
        }
    }
</script>

<style scoped>

    .legendelement {
        font-size: 1.125rem;
        font-family: Montserrat;
    }
    .dropdownelement {
        margin: 0 0 12px 0;
    }

    .dropdownelement select.error {
        background-color: rgba(158,0,59,0.05);
    }

    .dropdown {
        margin: 10px 0px;
    }

    .dropdown > select {
        width: 100%;
    }

    div > div.dropdown::after {
        position: absolute;
        right: 0.625rem;
        top: 0.75rem;
        filter: invert(10%) sepia(27%) saturate(5527%) hue-rotate(205deg) brightness(96%) contrast(106%);
    }

    p.toggle-item-visibility {
        display: flex;
        font-family: Open Sans;
        font-size: 1rem;
        color: var(--Traficom-main-color);
        cursor: pointer;
    }

    .element-with-path-icon::after {
        filter: invert(10%) sepia(27%) saturate(5527%) hue-rotate(205deg) brightness(96%) contrast(106%);
        margin-left: 15px;
    }

    .element-with-path-icon.open::after {
        transform: rotateZ(180deg);
    }
</style>
